import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Circle, Group, Line, Text } from 'react-konva';
/**
 * Компонент для отображения линейки на доске
 *
 * Отображает:
 * - Точку начала измерения (при удержании мыши)
 * - Линию от начальной точки до текущей позиции курсора
 * - Число с расстоянием (в пикселях или ячейках сетки)
 */
export const RulerTool = ({ startPoint, endPoint, distance, unit, zoom, }) => {
    if (!startPoint || !endPoint || distance === null) {
        return null;
    }
    const lineColor = '#62B2F8';
    const pointColor = '#62B2F8';
    const textColor = '#FFFFFF';
    const textBackgroundColor = '#142F44E1';
    // Форматируем расстояние для отображения
    const formatDistance = (dist, unit) => {
        if (unit === 'cells') {
            return `${Math.round(dist) * 5} фт.`;
            // return `${Math.round(dist) * 5} фт.`;
        }
        return `${Math.round(dist)} px`;
    };
    const distanceText = formatDistance(distance, unit);
    // Вычисляем позицию текста (середина линии, немного выше)
    const textX = (startPoint.x + endPoint.x) / 2;
    const textY = (startPoint.y + endPoint.y) / 2 - 20 / zoom;
    // Размер точки зависит от зума
    const pointRadius = 4 / zoom;
    const lineWidth = 2 / zoom;
    return (_jsxs(Group, { children: [_jsx(Line, { points: [startPoint.x, startPoint.y, endPoint.x, endPoint.y], stroke: lineColor, strokeWidth: lineWidth, lineCap: "round", lineJoin: "round", dash: [5 / zoom, 5 / zoom], listening: false }), _jsx(Circle, { x: startPoint.x, y: startPoint.y, radius: pointRadius, fill: pointColor, stroke: "#FFFFFF", strokeWidth: 1 / zoom, listening: false }), _jsxs(Group, { x: textX, y: textY, listening: false, children: [_jsx(Text, { text: distanceText, fontSize: 14 / zoom, fontFamily: "Nunito, sans-serif", fill: textBackgroundColor, stroke: textBackgroundColor, strokeWidth: 8 / zoom, align: "center", verticalAlign: "middle", padding: 6 / zoom, offsetX: 0, offsetY: 0 }), _jsx(Text, { text: distanceText, fontSize: 14 / zoom, fontFamily: "Nunito, sans-serif", fill: textColor, align: "center", verticalAlign: "middle", padding: 6 / zoom, offsetX: 0, offsetY: 0 })] })] }));
};
